import {
  KENLO_PAYMENTS_FIRST_LOAD_TIMEOUT_MS,
  KENLO_PAYMENTS_OPENING_ATTEMPTS,
  KENLO_PAYMENTS_SUBSEQUENT_TIMEOUT_MS,
} from "../constants/kenloPayments";

export function resolveKenloRequestTimeoutMs(hasCompletedLoad: boolean): number {
  return hasCompletedLoad
    ? KENLO_PAYMENTS_SUBSEQUENT_TIMEOUT_MS
    : KENLO_PAYMENTS_FIRST_LOAD_TIMEOUT_MS;
}

export function kenloLoadAttemptLimit(hasCompletedLoad: boolean): number {
  return hasCompletedLoad ? 1 : KENLO_PAYMENTS_OPENING_ATTEMPTS;
}
